export default [
	{
		title: 'Toggle video play/pause',
		key: 'Space',type: 'large',
	},
	{
		title: 'Add chapter at current time',
		key: 'b',type: 'square',
	},
	{
		title: 'Save chapter',
		key: 'Enter',type: 'medium',
	},
	{
		title: 'Cancel chapter',
		key: 'Esc',type: 'medium',
	},
	{
		title: 'Rewind video by 5 secs',
		key: '&#8592;',type: 'square',
	},
	{
		title: 'Fast forward video by 5 secs',
		key: '&#8594;',type: 'square',
	},
	{
		title: 'Increase video volume',
		key: '&#8593;',type: 'square',
	},
	{
		title: 'Decrease video volume',
		key: '&#8595;',type: 'square',
	},
]